import React, { useContext } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Footer from './app/footer/Footer';
import Home from './app/Home';
import Login from './app/login/Login';
import ForgotPassword from './app/login/ForgotPassword';
import RegisterPassword from './app/login/RegisterPassword';
import Header from './app/header/Header';
import PushNotificationPrompt from './app/components/PushNotificationPrompt';
import UserContext from './app/context/UserContext';
import { MobileMenuProvider } from './app/context/MobileMenuContext';
import { Sheet, Box } from '@mui/joy';
import { isAuthFreePath } from './app/util/authFreePaths';

const AppContent = () => {
  const location = useLocation();
  const { user } = useContext(UserContext);
  const isAuthPage = isAuthFreePath(location.pathname);
  const showPushPrompt = user && !isAuthPage;

  return (
    <Sheet
      variant="plain"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        height: isAuthPage ? 'auto' : '100vh',
        bgcolor: 'background.surface',
        m: 0,
        p: 0
      }}
    >
      <Header />
      <Box
        sx={{
          flex: isAuthPage ? '0 0 auto' : 1,
          width: '100%',
          m: 0,
          p: 0,
          overflow: isAuthPage ? 'visible' : 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/register/:hash" element={<RegisterPassword />} />
          <Route path="/*" element={<Home />} />
        </Routes>
      </Box>
      <Footer />
      {showPushPrompt && <PushNotificationPrompt />}
    </Sheet>
  );
};

function Router() {
  return (
    <BrowserRouter>
      <MobileMenuProvider>
        <AppContent />
      </MobileMenuProvider>
    </BrowserRouter>
  );
}

export default Router;
